module.exports = __webpack_public_path__ + "img/20110201_02.4813ae24.jpg";